import {instance} from "./instance";
import {NewChatData} from "../store";
import {compactChatFile} from "../services/chatFile";

export const send_message = (messageData: any) => {
    return instance.post('/chat/sendMessage', messageData)
}

export const new_chat_create = async (data: NewChatData) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        // appended below, after it's been shrunk
        if (key === 'chat_file') return;
        if (key === 'chat_language' || key === 'chat_members') {
            formData.append(key, JSON.stringify(value));
        } else if (value !== undefined && value !== null) {
            formData.append(key, value as any);
        }
    });
    if (data.chat_file) formData.append('chat_file', await compactChatFile(data.chat_file, data.chat_type));

    return instance.post('/chat/createNewChat', formData, {
        headers: {"Content-Type": "multipart/form-data"}
    });
}

// Messages come back oldest-first; pass `before` (a message's created_at) to load older ones
export const get_chat_messages = (id: string, before?: number, limit = 50) => {
    return instance.get(`/chat/${id}/messages`, {params: {before, limit}});
}

export const delete_chat_by_id = (id: string) => {
    return instance.delete(`/chat/${id}`);
}
